import { type ReduxUser, type CommunityBase } from 'models';
import { useMemo } from 'react';

import { getCreateEventPermissions } from '../utils';

export const useCreateEventPermissions = ({ viewer, community }: { viewer: ReduxUser; community?: CommunityBase }) =>
  useMemo(() => getCreateEventPermissions({ viewer, community }), [viewer, community]);
